export default "__VITE_ASSET__DNHYFeqT__"